import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="site-footer">
            <p>Alysia Promislow & Thomas Jeffries • September 2026</p>
        </footer>
    );
}

export default Footer;
